module.exports = __webpack_public_path__ + "static/avatar_3-dbfeddb091f86e630a6b924bbf1fe301.png";